import qs from 'qs';

const PropertyType = {
    namespaced: true,
    state: {
        propertyTypeData: [],
    },

    getters: {
        propertyTypeData (state) {
            return state.propertyTypeData;
        },
    },

    mutations: {

        /**
         * Установить значение вида собственности
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['propertyTypeData'] = items;
        },

        /**
         * Обновить значение элемента вида собственности
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['propertyTypeData'][index] = item;
        },

        /**
         * Добавить значение элемента вида собственности
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['propertyTypeData'].push(item);
        },

        /**
         * Удалить элемент из вида собственности
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['propertyTypeData'] = state['propertyTypeData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по видам собственности
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getPropertyTypeData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service' : rootGetters.service.propertyType,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по видам собственности получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN propertyType.js | getPropertyTypeData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по видам собственности !'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по видам собственности
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        savePropertyTypeData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service' : rootGetters.service.propertyType,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по видам собственности успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.propertyTypeId = response.data[0].propertyTypeId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый вид собственности успешно создана!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN propertyType.js | savePropertyTypeData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление вида собственности
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removePropertyTypeData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service' : rootGetters.service.propertyType,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Вид собственности успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении вида собственности!'),
                    console.log('ERROR IN propertyType.js | removePropertyTypeData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default PropertyType;





// WEBPACK FOOTER //
// ./src/store/modules/propertyType.js